"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const solutions = [{
  title: "AI, Data & Intelligent Systems",
  description: "Architecting scalable data foundations and deploying advanced AI models to turn raw information into predictive business intelligence and measurable performance.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604077/img/interactive_flat_panel_setup.png"
}, {
  title: "Enterprise Platforms & CRM",
  description: "Optimizing core operations with robust platform engineering, ensuring your CRM and ERP systems are integrated, automated, and aligned with growth outcomes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604077/img/video_wall_installation.png"
}, {
  title: "Automation & Workflow",
  description: "Eliminating operational friction through intelligent automation, streamlining complex enterprise processes to increase efficiency and reduce overhead.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604077/img/corporate_boardroom_av.png"
}, {
  title: "Digital Engineering",
  description: "Building high-performance digital products and infrastructure with a focus on scalability, security, and rapid market deployment for the modern enterprise.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604077/img/av_system_consulting.png"
}];
export default function EnterpriseAvSolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="135657" id="core-transformation-capabilities" className="dark bg-[#0B121E] text-foreground">
      {}
      <div className="bg-transparent py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-sans font-extrabold tracking-tighter text-white mb-6">
              Core Transformation Capabilities
            </h2>
            <p className="text-slate-400 text-lg md:text-xl font-sans">
              Quantificial provides AI-first consulting to modernize data, 
              deploy intelligent systems, and build the business-aligned 
              architecture required to move first in your industry.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {solutions.map((solution, i) => <div data-index={i} key={i} className="h-full">
                <Card className="h-full flex flex-col bg-[#161E2C] text-white border border-slate-800 rounded-none overflow-hidden group cursor-pointer shadow-lg hover:shadow-[0_0_40px_-10px_rgba(34,197,94,0.2)] hover:-translate-y-2 transition-all duration-500 p-0 gap-0">
                  <div className="w-full aspect-[4/3] overflow-hidden relative bg-slate-800">
                    <img src={solution.image} alt={solution.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                    {}
                    <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-300" />
                  </div>
                  
                  <div className="flex flex-col flex-grow p-6">
                    <CardHeader className="p-0 mb-3">
                      <CardTitle className="font-sans text-xl font-bold text-white tracking-tight leading-tight">
                        {solution.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="p-0 flex-grow">
                      <CardDescription className="text-slate-400 text-sm font-sans leading-relaxed">
                        {solution.description}
                        <span className="block mt-4 text-[10px] font-mono uppercase tracking-widest text-[#22c55e]">
                          Core Capability
                        </span>
                      </CardDescription>
                    </CardContent>
                  </div>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}